<template>
  <div class="topContainer">
    <el-row class="topBarContainer">
      <el-col class="leftContainer" :xs="3" :sm="6" :md="8" :lg="9">
        <i class="menuIcon" @click="showDropdown" v-if="!showback"></i>
        <i class="backIcon" @click="showBackBtn" v-if="showback"></i>
      </el-col>
      <el-col class="middleContainer" :xs="18" :sm="6" :md="8" :lg="9">
        <span>{{title}}</span>
      </el-col>
      <el-col class="rightContainer" :xs="3" :sm="6" :md="8" :lg="9">
        <el-dropdown @command="handleCommand" trigger="click">
          <i class="menuIcon"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">标记搜索</el-dropdown-item>
            <el-dropdown-item command="b">
              上传定位照片
              <input
                type="file"
                id="image1"
                accept="image/*"
                capture="camera"
                ref="camera"
                @change="imgUrl($event)"
              />
            </el-dropdown-item>
            <el-dropdown-item command="c">帮助手册</el-dropdown-item>
            <el-dropdown-item command="d">注销</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <div class="searchBar" v-if="searchShow">
        <el-input v-model="input" placeholder="请输入标记信息" clearable></el-input>
        <el-button type="primary" icon="el-icon-search" @click="remoteMethod()">搜索</el-button>
        <i class="close" @click="searchShow = false"></i>
        <div class="searchResult" v-if="searchResShow">
          <ul>
            <li
              v-for="(item,index) in searchOptions"
              :key="index"
              @click="toPicDetail(item)"
            >{{item.markerName}}</li>
          </ul>
        </div>
      </div>
      <el-drawer
        :visible.sync="showdropdownMenu"
        direction="ltr"
        @open="getProList"
        size="60%"
        :modal="false"
        :append-to-body="true"
      >
        <div class="drawer">
          <el-tree
            :data="cityListLazy"
            :props="props"
            lazy
            :load="loadNode"
            node-key="id"
            v-if="userType == 1 "
            @node-expand="getExpand"
            @node-click="nodeClick"
          ></el-tree>
          <el-tree
            :data="cityList"
            v-if="userType == 3 "
            :props="props1"
            @node-expand="getExpand"
            @node-click="nodeClick"
          ></el-tree>
        </div>
      </el-drawer>
    </el-row>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :markerList="dataNode" :centerCo="centerCo">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" :markerList="dataNode" :centerCo="centerCo">
      <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
    </router-view>
  </div>
</template>

<script>
import {
  disListPro,
  disListCity,
  disListOu,
  disListTown,
  disListRecord,
  disList,
  uploadFile,
  uploadImg
} from "../api/api";
export default {
  name: "framework",
  data() {
    return {
      title: "松材线虫病疫木监测平台",
      recordName: "永隆山",
      showdropdownMenu: false,
      userType: "",
      cityListLazy: [],
      cityList: [],
      props: {
        id: "id",
        children: "children",
        label: "label"
      },
      props1: {
        id: "id",
        children: "children",
        label: "label"
      },
      dataNode: {},
      showSearch: false,
      input: "",
      imageUrl: "",
      timer: null,
      searchOptions: [],
      centerCo: [],
      searchShow: false,
      searchResShow: false
    };
  },
  computed: {
    showback() {
      return this.$route.meta.showBack;
    }
  },
  methods: {
    handleCommand(command) {
      if (command === "c") {
        this.toHelp();
      } else if (command === "d") {
        this.logout();
      } else if (command === "b") {
        this.$refs.camera.click();
      } else {
        if (
          this.$store.state.markList.length &&
          this.$route.path.includes("map")
        ) {
          this.searchShow = true;
          this.input = ''
        } else {
          this.$message({
            message: "请先选择报告",
            type: "error"
          });
        }
      }
    },
    logout() {
      localStorage.clear();
      this.$router.push({
        path: "/login"
      });
    },
    showBackBtn() {
      this.$store.state.position = false;
      window.history.back(-1);
    },
    showDropdown() {
      this.showdropdownMenu = !this.showdropdownMenu;
    },
    loadNode(node, resolve) {
      let userId = localStorage.getItem("appUid");
      if (node.level === 1) {
        let para = {
          pId: node.data.pId,
          userId: userId
        };
        disListCity(para).then(res => {
          if (res.data.code === 600) {
            let data = res.data.data.map(item => {
              return {
                flag: false,
                id: "City" + item.cId,
                label: item.cityName,
                Lat: item.cityLat,
                Lon: item.cityLon,
                disabled: true,
                cId: item.cId
              };
            });
            resolve(data);
          }
        });
      }
      if (node.level === 2) {
        let params = {
          cId: node.data.cId,
          userId: userId
        };
        disListOu(params).then(res => {
          if (res.data.code === 600) {
            let data = res.data.data.map(item => {
              return {
                label: item.countyName,
                cId: item.cId,
                countyLon: item.countyLon,
                town: item.town,
                kmllist: item.kmllist,
                id: "County" + item.cId,
                disabled: true
              };
            });
            resolve(data);
          }
        });
      }
      if (node.level === 3) {
        let params = {
          cId: node.data.cId
        };
        disListTown(params).then(res => {
          if (res.data.code === 600) {
            let data = res.data.data.map(item => {
              return {
                flag: false,
                id: "Town" + item.tId,
                label: item.townName,
                Lat: item.townLat,
                Lon: item.townLon,
                disabled: false,
                tId: item.tId
              };
            });
            resolve(data);
          }
        });
      }
      if (node.level === 4) {
        let params = {
          tId: node.data.tId
        };
        disListRecord(params).then(res => {
          if (res.data.code === 600) {
            let data = res.data.data.map(item => {
              return {
                label: item.recordName,
                flag: true,
                id: "Record" + item.recordId,
                label: item.recordName,
                recordId: item.recordId,
                url: item.recordWPUrl,
                Lat: item.recordLat,
                Lon: item.recordLon,
                tilesetId: item.tilesetId
              };
            });
            resolve(data);
          }
        });
      }
      if (node.level === 5) {
        node.isLeaf = true; // 叶子
        resolve([]);
        return;
      }
    },
    getProList() {
      if (this.cityListLazy.length || this.cityList.length) {
        return;
      } else {
        let para = {
          userId: localStorage.getItem("appUid")
        };
        if (localStorage.getItem("appUtype") == 1) {
          disListPro(para).then(res => {
            if (res.data.code === 600) {
              this.cityListLazy = res.data.data.map(item => {
                return {
                  label: item.provinceName,
                  pId: item.pId,
                  Lon: item.provinceLon,
                  Lat: item.provinceLat,
                  city: item.city,
                  flag: false,
                  id: "Province" + item.pId
                };
              });
            }
          });
        } else {
          let para = {
            appUid: localStorage.getItem("appUid")
          };
          disList(para).then(res => {
            if (res.data.code === 600) {
              this.cityList = res.data.data.map(item3 => {
                return {
                  id: "Town" + item3.tId,
                  label: item3.townName,
                  Lat: item3.townLat,
                  Lon: item3.townLon,
                  disabled: true,
                  children: item3.record.map(item4 => {
                    return {
                      id: "Record" + item4.recordId,
                      label: item4.recordName,
                      recordId: item4.recordId,
                      url: item4.recordWPUrl,
                      Lat: item4.recordLat,
                      Lon: item4.recordLon,
                      linkRecordId: item4.linkRecordId,
                      recordFlag: item4.recordFlag
                    };
                  })
                };
              });
            }
          });
        }
      }
    },
    getExpand(data) {
      this.dataNode = {
        data: data
      };
    },
    nodeClick(data, data1, data2) {
      
      if (data.id.includes("Record")) {
        this.showSearch = true;
      } else {
        this.showSearch = false;
        this.input = "";
      }
      const arr = [];
      arr.push(data);

      data1.checked = !data1.checked;
     
      if (data.url && data1.checked) {
        this.dataNode = {
          item: arr.map(item => item.recordId),
          data: data
        };
        this.$store.state.lastNode = this.dataNode;
      }
    },
    toHelp() {
      this.$router.push({
        path: "/help"
      });
    },
    toPicDetail(item) {
      this.input = item.markerName;
      this.centerCo = [item.markerLon, item.markerLat];
      this.searchResShow = false;
    },
    imgUrl(e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      uploadFile(formData).then(res => {
        if (res.data.code === 600) {
          let para = {
            appUid: localStorage.getItem("appUid"),
            photoImage: res.data.data.fileUrl,
            photoLat: this.$store.state.coord[1],
            photoLon: this.$store.state.coord[0]
          };
          uploadImg(para).then(res => {
            if (res.data.code === 600) {
              this.$message({
                message: "上传成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    updateCo() {
      let options = {
        enableHighAccuracy: true,
        maximumAge: 10000
      };
      if (navigator.geolocation) {
        //浏览器支持geolocation
        navigator.geolocation.getCurrentPosition(
          this.success(),
          this.onError,
          options
        );
      } else {
        //浏览器不支持geolocation
        this.$toast.fail("浏览器不支持定位");
      }
    },
    success() {
      return position => {
        if(position.coords.accuracy <=10){
        let lng = position.coords.longitude;
        let lat = position.coords.latitude;
        this.$store.commit("updateCO", [lng, lat]);
        let creatDate = new Date();
        let para = {
          appUid: localStorage.getItem("appUid"),
          trackJson: {
            lat: lat,
            lon: lng,
            caretadate: creatDate.toLocaleDateString()
          }
        };
        getCo(para).then(res => {
          if (res.data.code === 600) {
            console.log("定位上传成功");
          }
        });
        } else {
                  let lng = position.coords.longitude;
        let lat = position.coords.latitude;
        this.$store.commit("updateCO", [lng, lat]);
        this.lat1 = lat;
        this.lng1 = lng;
        this.setCurrentLocation(lng, lat, flag);
        }

      };
    },
    remoteMethod() {
      if (this.input !== "") {
        this.searchOptions = this.$store.state.markList.filter(item => {
          //过滤数组元素
          return item.markerName.includes(this.input); //如果包含字符返回true
        });
        this.searchResShow = true;
      } else {
        this.searchOptions = [];
        this.$message({
          message: "暂无查找内容",
          type: "info"
        });
      }
    }
  },
  created() {
    this.userType = localStorage.getItem("appUtype");
    if (this.userType == 3) {
      if (this.timer) {
        clearInterval(this.timer);
      } else {
        this.timer = setInterval(() => {
          this.updateCo();
        }, 600000);
      }
    }
  },
  watch: {
    $route(to, from) {
      this.searchShow = false;
    }
  }
};
</script>

<style lang="less">
.topBarContainer {
  background: #022d6d;
  height: 130px;
  width: 100%;
  z-index: 1000;
  .leftContainer {
    color: #ffffff;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    line-height: 120px;
    padding-top: 30px;
    .menuIcon {
      display: inline-block;
      height: 40px;
      width: 40px;
      background-image: url("../assets/arrowDown.png");
      background-size: cover;
    }
    .backIcon {
      display: inline-block;
      height: 50px;
      width: 50px;
      background-image: url("../assets/leftArrow.png");
      background-size: cover;
    }
  }
  .middleContainer {
    font-size: 40px;
    color: #ffffff;
    text-align: center;
    line-height: 150px;
  }
  .rightContainer {
    color: #ffffff;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 120px;
    padding-top: 30px;
    .menuIcon {
      display: inline-block;
      height: 40px;
      width: 40px;
      background-image: url("../assets/menu.png");
      background-size: cover;
    }
  }
}
#image1 {
  opacity: 0;
  position: absolute;
}
.el-dropdown {
  font-size: 16px;
}
.searchBar {
  background: #022d6d;
  width: 100%;
  padding-bottom: 10px;
  height: 250px;
  .el-input {
    margin-left: 80px;
    width: 60%;
    height: 25px;
  }
  .close:before{
    content: '\3000';
    color: #022d6d
  }
  .close {
    margin-left: 40px;
    display: inline-block;
    height: 40px;
    width: 40px;
    background-image: url("../assets/close.png");
    background-size: cover;
    top: 5px;
  }
  .el-input__inner {
    height: 50px;
  }
  .searchResult {
    background: #ffffff;
    margin: 10px 0 15px 80px;
    height: 200px;
    overflow: scroll;
    width: 60%;
    border-radius: 3px;
    padding-left: 15px;
  }
  .el-button--primary {
    background: #0eb871;
  }
}
.drawer {
  margin-top: 8px;

}
.el-tree-node__content {
  margin: 8px !important;
}
.el-tree-node__label {
  font-size: 30px !important;
}
.el-dropdown-menu {
  height: 200px;
  width: 250px;
  margin-top: -30px;
  left:490px!important;
}
.el-dropdown-menu__item {
  font-size: 30px !important;
}
#el-drawer__title {
  background: #022d6d;
  height: 50px;
  margin-bottom: 0;
}
.el-drawer__body{
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/framework1.vue